/** Anchos relativos columnas B–F (plantilla Invoice 5019). */
export const HT_PDF_COL_FRAC = [12.22, 41.44, 54.44, 66.78, 13];

export function htPdfColWidthsMm(totalW) {
  const sum = HT_PDF_COL_FRAC.reduce((a, b) => a + b, 0);
  return HT_PDF_COL_FRAC.map((f) => (f / sum) * totalW);
}

export function htPdfColumnStyles(contentW) {
  const cols = htPdfColWidthsMm(contentW);
  const styles = {};
  cols.forEach((w, i) => {
    styles[i] = { cellWidth: w };
  });
  return styles;
}
